import * as actionTypes from './actionTypes';

export const reportIssueStart = () => {
    return {
        type: actionTypes.REPORT_ISSUE_START
    }
}

export const reportIssue = (data) => {
    return {
        type: actionTypes.REPORT_ISSUE,
        data: data
    }
}

export const reportIssueSuccess = (message) => {
    return {
        type: actionTypes.REPORT_ISSUE_SUCCESS,
        message: message
    }
}

export const reportIssueFail = () => {
    return {
        type: actionTypes.REPORT_ISSUE_FAIL
    }
}